import { ComponentPropsWithoutRef, ReactNode } from "react"
import { IconCourse, IconMail, IconOnline, IconPaper, IconPhone, IconStar } from "./Icons"

/**
 * Update /backend/admin/icon.php as well!
 */
const ICONS = {
  file: IconPaper,
  mail: IconMail,
  phone: IconPhone,
  course: IconCourse,
  online: IconOnline,
  star: IconStar,
}

export type ChosenIconName = keyof typeof ICONS

type Props = ComponentPropsWithoutRef<"svg"> & {
  icon: ChosenIconName
  fallbackIcon?: ChosenIconName
}

/**
 * Renders an author-chosen icon. Use ACF field name 'icon'.
 * Icon list is maintained in two spots:
 * /components/svg/ChosenIcon.tsx
 * /backend/admin/icon.php
 */
export function ChosenIcon({ icon, fallbackIcon, ...props }: Props) {
  const IconComponent = ICONS[icon] ?? ICONS[fallbackIcon ?? "file"]

  if (!IconComponent) return null
  return <IconComponent {...props} />
}
